import {Group} from 'src/design/atoms/Group';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {IconClipboard} from '@tabler/icons-react';
import React from 'react';
import type { PillProps} from 'src/design/atoms/Pill';
import {Pill} from 'src/design/atoms/Pill';
import {ContentHeader, SectionTitle} from 'src/design/atoms/Typography';
import {AnonymousSubmissionText} from 'src/app/forms/AnonymousSubmissionText';

/**
 * FormContentHeader - A simple content header for displaying form information.
 * Used for print views and form previews, not for page navigation.
 * For page-level headers with actions, use src/design/organisms/PageHeader.
 */
export interface FormContentHeaderProps {
  text: string;
  subtext?: string;
  subTextComponent?: React.ReactNode;
  hideIcon?: boolean;
  icon?: React.ReactNode;
  internalIdentifier?: string;
  pills?: PillProps[];
  pillsV2?: PillProps[];
  isAnonymousForm?: boolean;
}

export const FormContentHeader = ({
  text,
  subtext,
  subTextComponent,
  icon,
  hideIcon = false,
  internalIdentifier,
  pills,
  pillsV2,
  isAnonymousForm,
}: FormContentHeaderProps) => (
  <Stack gap="xs" mb="sm">
    <Group align="center" gap="xs">
      {hideIcon !== true && (
        <>{icon ?? <IconClipboard size={20} />}</>
      )}
      <ContentHeader text={text} />
    </Group>

    {isAnonymousForm === true && <AnonymousSubmissionText />}

    {subtext && <SectionTitle text={subtext} />}

    {(internalIdentifier || pills || pillsV2) && (
      <Group align="center" gap="xs">
        {internalIdentifier && (
          <Text size="sm" c="dimmed">
            {internalIdentifier}
          </Text>
        )}
        {pills?.map(pill => {
          return <Pill key={pill.text} text={pill.text} color={pill.color} />;
        })}
        {pillsV2?.map(pill => {
          return <Pill key={pill.text} text={pill.text} color={pill.color} />;
        })}
      </Group>
    )}

    {subTextComponent && <>{subTextComponent}</>}
  </Stack>
);
